/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Confirm } from '@mairistem/composants';

interface PanelModalEditionConfirmCloseProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const PanelModalEditionConfirmClose = (
  props: PanelModalEditionConfirmCloseProps,
) => {
  const { onConfirm, onCancel } = props;

  return (
    <Confirm
      open
      content="Des modifications sont en cours, êtes-vous sûrs de vouloir quitter ?"
      cancelButton={
        <Button
          data-testid="panel-modal-edit-confirm-cancel-button"
          basic
          size="tiny"
          icon="cancel"
          content="Annuler"
        />
      }
      confirmButton={
        <Button
          data-testid="panel-modal-edit-confirm-confirm-button"
          positive
          icon="check"
          content="Confirmer"
        />
      }
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};

export default PanelModalEditionConfirmClose;
